import header from './header.component';

// Imported rather than `<script src>`-ed so header.component.ts stays one module (coverage keeps one
// copy's counts); the shallow copy gives this SFC its own component object, as in sable-header.
export default { ...header };
